import { Component, Inject, Input } from '@angular/core';
import { CarrierWithPayerAndState } from 'src/app/Models/CarrierWithPayerAndState';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { DeletePayerMapping } from 'src/app/Models/DeletePayerMapping';

@Component({
    selector: 'app-delete-mapping',
    templateUrl: './delete-mapping.component.html',
    styleUrls: ['./delete-mapping.component.css'],
    standalone: false
})
export class DeleteMappingComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteMappingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CarrierWithPayerAndState[],
    private dataSvc: DataService) { }

  displayedColumns: string[] = ['carrierName', 'payerName'];

  deleteButtonClicked() {
    // Logic to delete the selected mappings
    console.log('Delete mappings:', this.data);
    const payerMappings = [...this.data.map((row: CarrierWithPayerAndState) => {
      return {
        carrierPayerId: row.carrierPayerId,
        payerStatesId: row.payerStatesId

      } as DeletePayerMapping;
    })];
    const allObservables = [
      ...payerMappings.map(payerMapping => this.dataSvc.deletePayerMapping(payerMapping))
    ];
    forkJoin(allObservables).subscribe(() => {
      console.log('Completed all delete requests');
      this.dialogRef.close();
    });
  }
}
